import { Typography } from "@mui/material";
import clsx from "clsx";
import { useTranslations } from "next-intl";

export const Card = ({ text, subText, children }) => {
  const t = useTranslations();
  return (
    <div
  className={clsx(
    "flex",
    "flex-col",
    "items-center",
    "justify-start",   
    "gap-2",
    "sm:gap-4",
    "w-full",
    "max-w-[calc(50%-8px)]", 
    "sm:max-w-70",
    "h-full",               
    "min-h-[200px]"          
  )}
>

      {children}
      <Typography 
        variant="h6" 
        className="sm:text-h5"
      >
        {t(text)}
      </Typography>
      <Typography 
        sx={{ textAlign: "center" }}
        className="hidden sm:block"
      >
        {t(subText)}
      </Typography>
    </div>
  );
};